import React from "react";
import Add from "./Add";
import Edit from "./Edit";
import Overview from "./Overview";
import { PageProvider } from "../../context/PageContext";

export const Page = () => {
  return (
    <PageProvider>
      <Overview />
    </PageProvider>
  );
};

export const AddPage = () => {
  return (
    <PageProvider>
      <Add />
    </PageProvider>
  );
};

export const EditPage = () => {
  return (
    <PageProvider>
      <Edit />
    </PageProvider>
  );
};
